<app-deprecated-confirmation-dialog
    #confirmDeleteTaskTemplateDialog
    [label]="'Delete'"
    [description]="'Deleting this task will not remove previous assignees.'"
    [negative]="true"
></app-deprecated-confirmation-dialog>

<!-- Body -->
<div class="page-container">
    <app-header title="People" [menuService]="employeeModuleMenuService">
        <div class="buttons" *ngIf="hasTaskPermission">
            <ui-button type="primary" (click)="onNewTask($event)"
                ><mat-icon svgIcon="plus"></mat-icon>Create Task Template</ui-button
            >
        </div>
    </app-header>

    <div class="taskTemplates">
        <!--show table if there are tasks-->
        <app-table [table]="table" (menuItemSelected)="onTableMenuEvent($event)">
            <div class="empty">
                <h2 class="ui centered header">
                    <ng-container *ngIf="table.hasFiltersApplied(); else emptyState">
                        No task templates found for the applied filters.
                    </ng-container>
                    <ng-template #emptyState> You have not yet created any onboarding task templates. </ng-template>
                </h2>
            </div>
        </app-table>
    </div>
</div>
